import { render } from "./warehousingSelect.vue?vue&type=template&id=03506fc5"
import script from "./warehousingSelect.vue?vue&type=script&lang=js"
export * from "./warehousingSelect.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__